import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ e("path", { d: "M6.25 1a.75.75 0 0 1 1.5 0v3.97c0 .044 0 .107-.008.178-.02.2-.107.818-.478 1.405-.304.48-.791.923-1.514 1.107V15h-1.5V7.652A2.53 2.53 0 0 1 2.846 6.65a3.59 3.59 0 0 1-.568-1.39 1.93 1.93 0 0 1-.028-.345V1a.75.75 0 0 1 1.5 0v3.914c0 .05.003.07.004.079.029.159.115.503.318.791.18.256.446.466.928.466.568 0 .834-.243.996-.499.189-.298.242-.643.253-.754v-.004l.001-.023V1Zm-2 14a.75.75 0 1 0 1.5 0h-1.5Z" }, null, -1), n = /* @__PURE__ */ e("path", { d: "M4.25 1a.75.75 0 0 1 1.5 0h-1.5Zm0 0v3.324a.75.75 0 0 0 1.5 0V1h-1.5Z" }, null, -1), a = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "m13.002 1-.64-.392a.75.75 0 0 1 1.39.392v14a.75.75 0 1 1-1.5 0V9.366l-.013-.01a6.495 6.495 0 0 1-.78-.688c-.551-.575-1.209-1.494-1.209-2.654 0-.56.156-1.184.353-1.763.2-.591.465-1.193.723-1.726A24.993 24.993 0 0 1 12.336.65l.019-.03.005-.008.002-.004.64.392ZM11.75 6.014c0 .452.203.888.502 1.279V4.125c-.084.205-.161.41-.23.609-.178.525-.272.965-.272 1.28Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  l,
  n,
  a
];
function s(h, r) {
  return t(), o("svg", c, [...d]);
}
const i = { render: s };
export {
  i as default,
  s as render
};
